import { getTextStyles as e } from "./textStyles.es.js";
import { Text as t } from "./components/index.es.js";
// lib/Text/index.tsx
var n = (n) => ({
	class: "text",
	name: "core/text",
	options: n,
	componentEntry: {
		class: "text",
		component: t,
		placeholder: (e) => {
			switch (e.properties?.role) {
				case "heading-1": return typeof n?.titleLabel == "string" ? n.titleLabel : "¶";
				case "heading-2": return typeof n?.subTitleLabel == "string" ? n.subTitleLabel : "¶";
				case "preamble": return typeof n?.preambleLabel == "string" ? n.preambleLabel : "¶";
				case "vignette": return typeof n?.vignetteLabel == "string" ? n.vignetteLabel : "¶";
				default: return "¶";
			}
		},
		constraints: {
			allowBreak: !n?.singleLine,
			allowSoftBreak: !n?.singleLine
		}
	},
	actions: e(n || {})
});
export { n as Text };
